export function formatIndianNumber(value) {
  const num = String(value).replace(/[^0-9]/g, '');
  if (!num) return '';
  const lastThree = num.slice(-3);
  const rest = num.slice(0, -3);
  if (!rest) return lastThree;
  return rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + ',' + lastThree;
}

export function parseNumber(formatted) {
  return String(formatted).replace(/,/g, '');
}
